var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"basic-button",class:{'disabled': _vm.btnDisabled, 'has-shadow': _vm.hasShadow},on:{"click":function($event){$event.stopPropagation();return _vm.onBodyClick($event)}}},[_c('span',{staticClass:"text-wrap",style:({'background': _vm.paramBackground,})},[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5513e9a8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/YearLuck/y2023/partials/BasicButton.vue
// module id = null
// module chunks = 